<template>
  <div>
    <div class="wrap myinfo-wrap">
      <div class="top-header">
        <h3>My Info</h3>
      </div>
      <div class="body-wrap">
        <div class="con-01 con">
          <ul v-for="(item, index) in userInfo.myCoachingList" :key="index">
            <div style="text-align: center; font-weight: bold; padding-bottom: 10px">{{ item.courseName }}</div>
            <li>
              <h4>
                나의 회기
                <!-- <p><span class="bold">{{item.sessionPer}}</span>/{{item.onePerson}} (코칭 완료 기준입니다)</p> -->
                <p>
                  <span class="bold">{{ item.completedSessionCount }}</span
                  >/{{ item.courseOneperson }} (코칭 완료 기준입니다)
                </p>
              </h4>
            </li>
            <li>
              <h4>
                과정 기간
                <p>{{ item.courseGigan }}</p>
              </h4>
            </li>
          </ul>
        </div>
        <div class="con-02 con">
          <ul>
            <li>
              <h4>
                이름
                <p>{{ this.$store.state.userInfo.userName }}</p>
              </h4>
            </li>
            <li>
              <h4>
                ID(이메일)
                <p>{{ this.$store.state.userInfo.userId }}</p>
              </h4>
            </li>
            <li>
              <h4>
                비밀번호
                <button @click="passwordTrans()">비밀번호 변경하기</button>
              </h4>
            </li>
          </ul>
        </div>
        <div class="con-03 con">
          <h4>알림 설정</h4>
          <ul>
            <li class="clear">
              <h4 class="clear">
                <p class="float-left">App 알림</p>
                <!-- <p><span></span></p> -->
                <toggle-button
                  v-model="toggleValue"
                  color="#4cda64"
                  :sync="true"
                  :labels="true"
                  :width="60"
                  :height="30"
                  class="float-right"
                  @change="onToogleHandler"
                />
              </h4>
            </li>
            <li>
              <h4 class="clear">
                <p class="float-left">알림톡 수신</p>
                <toggle-button
                  v-model="toggleValue1"
                  color="#4cda64"
                  :sync="true"
                  :labels="true"
                  :width="60"
                  :height="30"
                  class="float-right"
                  @change="onToogleHandler"
                />
                <!-- <p><span></span></p> -->
              </h4>
            </li>
            <li>
              <h4>
                <p class="float-left">이메일 수신</p>
                <toggle-button
                  v-model="toggleValue2"
                  color="#4cda64"
                  :sync="true"
                  :labels="true"
                  :width="60"
                  :height="30"
                  class="float-right"
                  @change="onToogleHandler"
                />
                <!-- <p><span></span></p> -->
              </h4>
            </li>
            <li>
              <h4>
                <p class="float-left">앱 버전</p>
                <p class="float-right">{{ version }}</p>
                <!-- <p><span></span></p> -->
              </h4>
            </li>
          </ul>
        </div>
        <button class="logout" @click="logout()">로그아웃</button>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import { App } from "@capacitor/app";
import incTab from "@/components/inc/inc_tab.vue";
export default {
  name: "myinfo",
  data: () => ({
    toggleValue: true,
    toggleValue1: false,
    toggleValue2: true,
    userInfo: {},
    version: "",
  }),
  components: {
    incTab,
  },
  mounted() {
    App.getInfo().then((value) => {
      this.version = value.version;
    });
    this.getMyInfo();
  },
  methods: {
    onToogleHandler() {
      let userAppYn = this.toggleValue == true ? "0" : "1";
      let userKakaoYn = this.toggleValue1 == true ? "0" : "1";
      let userEmailYn = this.toggleValue2 == true ? "0" : "1";
      let form = new FormData();
      form.append("userIdx", this.$store.state.userInfo.userIdx);
      form.append("userEmailYn", userEmailYn);
      form.append("userKakaoYn", userKakaoYn);
      form.append("userAppYn", userAppYn);
      this.axios
        .post("/front/user/edit/yn", form)
        .then((res) => {
          if (res.data.success) {
            this.getMyInfo();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMyInfo() {
      this.axios
        .get("/front/searchmyinfo")
        .then((res) => {
          if (res.data.success) {
            this.userInfo = res.data.contentinfo;
            this.toggleValue = this.userInfo.appYn == "0" ? true : false;
            this.toggleValue1 = this.userInfo.alarmTalkYn == "0" ? true : false;
            this.toggleValue2 = this.userInfo.emailYn == "0" ? true : false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    passwordTrans() {
      this.$router.push({ name: "password_trans", params: { idx: btoa(this.$store.state.userInfo.userIdx), isAccount: 0 } });
    },
    logout() {
      this.axios
        .get("/auth/user-logout")
        .then((res) => {
          if (res.data.success) {
            localStorage.clear();
            location.href = "/";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
